<template>
  <div class="register">
    <p class="title">{{ $t("components.aanmelden_2") }}</p>
    <form class="registerForm" @submit.prevent="goToLogin">
      <div class="row">
        <div class="form-group">
          <label for="voornaam">Voornaam<span>*</span></label>
          <input
            type="text"
            v-model="regName"
            name="voornaam"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('voornaam') }"
          />
          <!-- display feedback if input is invalid -->
          <div
            v-if="submitted && errors.has('voornaam')"
            class="invalid-feedback"
          >
            {{ errors.first("voornaam") }}
          </div>
        </div>
        <div class="form-group">
          <label for="email">{{ $t("components.adres") }}<span>*</span></label>
          <input
            type="email"
            v-model="regMail"
            name="email"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('email') }"
          />
          <div v-if="submitted && errors.has('email')" class="invalid-feedback">
            {{ errors.first("email") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <label for="bedrijf">Bedrijf<span>*</span></label>
          <input
            type="text"
            v-model="regCompany"
            name="bedrijf"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('bedrijf') }"
          />
          <!-- display feedback if input is invalid -->
          <div
            v-if="submitted && errors.has('bedrijf')"
            class="invalid-feedback"
          >
            {{ errors.first("bedrijf") }}
          </div>
        </div>
        <div class="form-group">
          <label for="telefoonnummer">Telefoonnummer<span>*</span></label>
          <input
            type="tel"
            v-model="regPhone"
            name="telefoonnummer"
            class="form-control"
            :class="{ 'is-invalid': submitted && errors.has('telefoonnummer') }"
          />
          <!-- display feedback if input is invalid -->
          <div
            v-if="submitted && errors.has('telefoonnummer')"
            class="invalid-feedback"
          >
            {{ errors.first("telefoonnummer") }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="form-group">
          <label for="password"
            >{{ $t("components.wachtwoord") }}<span>*</span></label
          >
          <!-- v-validate="{ required: true, min: 6 }" -->
          <input
            type="password"
            v-model="regPassword"
            name="password"
            class="form-control"
            placeholder="Wachtwoord"
            ref="password"
            :class="{ 'is-invalid': submitted && errors.has('password') }"
          />
          <!-- display feedback if input is invalid -->
          <div
            v-if="submitted && errors.has('password')"
            class="invalid-feedback"
          >
            {{ errors.first("password") }}
          </div>
        </div>
        <div class="form-group">
          <label for="newpassRepeat">Check Wachtwoord<span>*</span></label>
          <input
            type="password"
            v-model="regPasswordConfirm"
            name="newpassRepeat"
            class="form-control"
            placeholder="Check wachtwoord"
            data-vv-as="password"
            :class="{ 'is-invalid': errors.has('newpassRepeat') }"
          />
          <!-- display feedback if input is invalid -->
          <div v-if="errors.has('newpassRepeat')" class="invalid-feedback">
            {{ errors.first("newpassRepeat") }}
          </div>
        </div>
      </div>
      <div class="buttonSection">
        <div class="form-group">
          <button type="submit" class="btn btn-primary">
            {{ $t("components.aanmelden_2") }}
          </button>
        </div>
      </div>
      <div class="wrap">
        <p class="body1">{{ $t("components.al_login") }}</p>
        <p class="body1 link" @click="setPageRoute('login')">
          {{ $t("components.login") }}
        </p>
      </div>
    </form>
  </div>
</template>

<script>
// import { mapMutations } from "vuex";
// export default {
//   data() {
//     return {
//       regName: "",
//       regMail: "",
//       regCompany: "",
//       regPhone: "",
//       regPassword: "",
//       regPasswordConfirm: "",
//       submitted: false,
//     };
//   },
//   methods: {
//     validationSet() {
//       const rules = {
//         voornaam: {
//           rule: {
//             required: true,
//           },
//           value: this.regName,
//         },
//         email: {
//           rule: {
//             required: true,
//             email: true,
//           },
//           value: this.regMail,
//         },
//         bedrijf: {
//           rule: {
//             required: true,
//           },
//           value: this.regCompany,
//         },
//         telefoonnummer: {
//           rule: {
//             required: true,
//           },
//           value: this.regPhone,
//         },
//         password: {
//           rule: {
//             required: true,
//             min: 6,
//           },
//           value: this.regPassword,
//         },
//         newpassRepeat: {
//           rule: {
//             required: true,
//             confirmed: this.regPassword,
//           },
//           value: this.regPasswordConfirm,
//         },
//       };

//       return rules;
//     },
//     goToLogin() {
//       this.submitted = true;
//       if (this.validation(this.validationSet())) {
//         this.$emit("goToLogin", {
//           regname: this.regName,
//           regmail: this.regMail,
//           regcompany: this.regCompany,
//           regphone: this.regPhone,
//           regpass: this.regPassword,
//           regpassconfirm: this.regPasswordConfirm,
//         });
//       }
//     },
//     ...mapMutations("auth", ["setPageRoute"]),
//   },
// };

import { ref, computed, getCurrentInstance } from "vue";
import { useStore } from "vuex";

export default {
  setup(props, { emit }) {
    const store = useStore();

    // Define reactive data
    const regName = ref("");
    const regMail = ref("");
    const regCompany = ref("");
    const regPhone = ref("");
    const regPassword = ref("");
    const regPasswordConfirm = ref("");
    const submitted = ref(false);

    // Access Global Validation
    const instance = getCurrentInstance();
    const validation = instance.appContext.config.globalProperties.validation;

    // Define methods
    const validationSet = () => {
      const rules = {
        voornaam: {
          rule: {
            required: true,
          },
          value: regName.value,
        },
        email: {
          rule: {
            required: true,
            email: true,
          },
          value: regMail.value,
        },
        bedrijf: {
          rule: {
            required: true,
          },
          value: regCompany.value,
        },
        telefoonnummer: {
          rule: {
            required: true,
          },
          value: regPhone.value,
        },
        password: {
          rule: {
            required: true,
            min: 6,
          },
          value: regPassword.value,
        },
        newpassRepeat: {
          rule: {
            required: true,
            confirmed: regPassword.value,
          },
          value: regPasswordConfirm.value,
        },
      };

      return rules;
    };

    const goToLogin = () => {
      submitted.value = true;
      if (validation(validationSet())) {
        emit("goToLogin", {
          regname: regName.value,
          regmail: regMail.value,
          regcompany: regCompany.value,
          regphone: regPhone.value,
          regpass: regPassword.value,
          regpassconfirm: regPasswordConfirm.value,
        });
      }
    };

    const setPageRoute = (page) => {
      store.commit("auth/setPageRoute", page);
    };

    // Return reactive data and methods
    return {
      regName,
      regMail,
      regCompany,
      regPhone,
      regPassword,
      regPasswordConfirm,
      submitted,
      validationSet,
      goToLogin,
      setPageRoute,
    };
  },
};
</script>

<style lang="sass" scoped>
.register
  color: $black
  display: flex
  height: 100%
  flex-direction: column
  .title
    font-size: 28px
    line-height: 45px
    font-weight: 300
    margin: 0
    margin-bottom: 20px
    text-align: center
  .registerForm
    justify-content: center
    width: 100%
    height: 100%
    overflow-y: auto
    overflow: -moz-scrollbars-none
    -ms-overflow-style: none
    &::-webkit-scrollbar
      width: 0 !important
    .row
      display: flex
      justify-content: space-between
      flex-direction: column
      .form-group
        display: flex
        flex-direction: column
        width: 100%
        margin-bottom: 15px
        &:focus-within
          color: #104E8A
        label
          margin-bottom: 10px
          span
            color: $red
        input
          padding: 5px
          font-size: 15px
          line-height: 24px
          font-family: Ubuntu
          border: none
          border-bottom: 1px solid $grey
          &:focus
            color: #104E8A
            border-bottom: 1px solid #104E8A
            outline: none
        .invalid-feedback
          color: $red
          font-size: 0.8em
        .is-invalid
          border: 1px solid $red
    .buttonSection
      .form-group
        display: flex
        width: 100%
        justify-content: space-around
        a
          text-decoration: none
        .btn
          border: none
          height: 45px
          width: 100%
          display: flex
          -webkit-box-align: center
          -ms-flex-align: center
          align-items: center
          justify-content: center
          font-weight: 500
          font-size: 15px
          line-height: 24px
          text-align: center
          border-radius: 22.5px
          background-color: $red
          color: $white
          transition: background-color 300ms ease
          margin-top: 10px
          &:hover
            background-color: #CA3233
    .wrap
      margin-top: 30px
      display: flex
      justify-content: center
      height: 20px
      margin-bottom: 10px
      .body1
        text-align: center
        font-size: 15px
        line-height: 20px
        margin: 0
      .link
        text-decoration: none
        color: $black
        font-weight: 500
        margin-left: 5px
        &:hover
          cursor: pointer

@media only screen and (min-width: 576px)
  .register
    .registerForm
      .row
        flex-direction: row
        .form-group
          width: 45%
</style>
